import { render } from "./VSelect.vue?vue&type=template&id=497d8f9c"
import script from "./VSelect.vue?vue&type=script&lang=ts"
export * from "./VSelect.vue?vue&type=script&lang=ts"

const cssModules = script.__cssModules = {}
import style0 from "./VSelect.vue?vue&type=style&index=0&id=497d8f9c&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script